import React from 'react';
import { Footer } from 'components/Footer/Footer';
import { BodyContainer } from 'components/Containers/BodyContainer/BodyContainer';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import ContainerManager from 'partial/OfferManager/ContainerManager.js';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';
import GradeDialController from 'pages/GradeDial';
import { LoadingFactorView } from './LoadingFactorView';
import { SignUpBanner } from './SignUpBanner/SignUpBanner';
import { SomethingErrorFactorView } from './SomethingErrorFactorView';
import {
  FACTOR_ENUMS,
  BUREAU_ENUMS,
  BUREAU_ATTRIBUTE_NAME_MAP,
} from '../constants';
import CreditFactorsDashboardModule from 'partial/OfferManager/modules/ModuleRepository/CreditFactorsDashboardModule';
import TodayDashboardModule from 'partial/OfferManager/modules/ModuleRepository/TodayDashboardModule';
import { getGradeDialData } from '../../GradeDial/helpers/utils';
import { SesameGradeBanner } from './SesameGradeBanner';
import ScoreSimulatorBannerModuleController from 'partial/OfferManager/modules/ScoreSimulatorBannerModule/ScoreSimulatorBannerModuleController';
import { VerifyAccountBanner } from './VerifyAccountBanner/VerifyAccountBanner';
import { OVERVIEW } from 'types/mrph.pageName.constants';
import { HeadingHidden } from 'components/HeadingHidden/HeadingHidden';

export const LoadingView = PageLoadingMask;

const { POTENTIAL_CREDIT_PROFILE } = FACTOR_ENUMS;

const LoadingDashboardView = props => {
  const {
    isFactorContainerLoading,
    todayContainerLoading,
    potentialCreditProfileContainerError,
    selectedFactor,
    handleTryAgainPotentialCreditProfile,
  } = props;
  if (
    (isFactorContainerLoading || todayContainerLoading || !selectedFactor) &&
    !potentialCreditProfileContainerError
  ) {
    return <LoadingFactorView />;
  } else if (
    potentialCreditProfileContainerError &&
    selectedFactor === POTENTIAL_CREDIT_PROFILE
  ) {
    return (
      <SomethingErrorFactorView
        handleClickTryAgain={handleTryAgainPotentialCreditProfile}
      />
    );
  } else {
    return <></>;
  }
};

export const DashboardView = props => {
  const {
    staticModules,
    staticModulesThree,
    profileContainer,
    potentialCreditProfileContainer,
    todayContainer,
    profileContainerLoading,
    potentialCreditProfileContainerLoading,
    todayContainerLoading,
    selectedBureau,
    selectedFactor,
    loadTodayDashboard,
    onBureauSelection,
    isFactorContainerLoading,
    userInfo,
    eventHandler,
    history,
    isFreeSignUpBannerShow,
    potentialCreditProfileContainerError,
    handleTryAgainPotentialCreditProfile,
    goToFactorPage,
    location,
    config,
    showModuleAvailableForYou,
  } = props;

  const overallCSGrade = React.useMemo(() => {
    const key = BUREAU_ATTRIBUTE_NAME_MAP.get(BUREAU_ENUMS.TRANS_UNION);
    return getGradeDialData(profileContainer)?.creditFactorData?.[key]
      ?.sesameGrade?.qualification;
  }, [profileContainer]);

  const isSignUpBannerShow =
    isFreeSignUpBannerShow?.showSignUpBanner && selectedFactor === 'TODAY';

  const isVerifyAccountBannerShow =
    (!userInfo?.emailConfirmed || !userInfo?.contactPhoneNumberConfirmed) &&
    config?.showVerifyAccountBanner;
  return (
    <BodyContainer>
      <HeadingHidden title={OVERVIEW} />
      {isVerifyAccountBannerShow && (
        <VerifyAccountBanner
          {...userInfo}
          onClick={() => history.push('/verifyAccountPrivate')}
        />
      )}
      <FlexContainer
        className={'m-flex-column justify-between margt16 m-margt0'}
      >
        {isSignUpBannerShow && !isFactorContainerLoading && (
          <FlexContainer className={'d-hide'}>
            <SignUpBanner
              eventHandler={eventHandler}
              userInfo={userInfo}
              isFreeSignUpBannerShow={isFreeSignUpBannerShow}
              className={'margb20'}
            />
          </FlexContainer>
        )}
        <FlexContainer
          className={classnames(
            'format50 m-format100 flex-column m-items-align-center',
          )}
        >
          <GradeDialController
            profileContainer={profileContainer}
            potentialCreditProfileContainer={potentialCreditProfileContainer}
            todayContainer={todayContainer}
            isFactorContainerLoading={isFactorContainerLoading}
            profileContainerLoading={profileContainerLoading}
            potentialCreditProfileContainerLoading={
              potentialCreditProfileContainerLoading
            }
            todayContainerLoading={todayContainerLoading}
            selectedBureau={selectedBureau}
            selectedFactor={selectedFactor}
            loadTodayDashboard={loadTodayDashboard}
            onBureauSelection={onBureauSelection}
            userInfo={userInfo}
            handleTryAgainPotentialCreditProfile={
              handleTryAgainPotentialCreditProfile
            }
            goToFactorPage={goToFactorPage}
            location={location}
            {...props}
          />

          {config?.creditFactors?.potential?.showPotentialBanner && (
            <ScoreSimulatorBannerModuleController
              userInfo={userInfo}
              eventHandler={eventHandler}
              history={history}
              isPotential={
                FACTOR_ENUMS.POTENTIAL_CREDIT_PROFILE === selectedFactor
              }
            />
          )}
        </FlexContainer>

        <FlexContainer
          className={`${config?.dashboardStyle?.creditTool?.width} m-format100 flex-column m-margt6`}
        >
          <FlexContainer
            className={classnames('width100 flex-column', {
              bgWhite: selectedFactor !== 'TODAY',
            })}
          >
            <LoadingDashboardView
              isFactorContainerLoading={isFactorContainerLoading}
              todayContainerLoading={todayContainerLoading}
              potentialCreditProfileContainerError={
                potentialCreditProfileContainerError
              }
              selectedFactor={selectedFactor}
              handleTryAgainPotentialCreditProfile={
                handleTryAgainPotentialCreditProfile
              }
            />
            {!isFactorContainerLoading && (
              <FlexContainer className={'flex-column'}>
                {isSignUpBannerShow && (
                  <FlexContainer className={'m-hide t-hide'}>
                    <SignUpBanner
                      userInfo={userInfo}
                      eventHandler={eventHandler}
                      isFreeSignUpBannerShow={isFreeSignUpBannerShow}
                      className={'marglr10 border-rad4px margt30'}
                    />
                  </FlexContainer>
                )}
                <ContainerManager
                  staticModules={staticModules}
                  preventInnerLoading
                  isDefaultModuleViewDisabled
                  CustomModuleRepository={CreditFactorsDashboardModule}
                />
              </FlexContainer>
            )}
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      {!todayContainerLoading &&
        staticModulesThree?.modules?.length > 0 &&
        selectedFactor === 'TODAY' && (
          <FlexContainer className={'flex-column margT34'}>
            {/* the below div is used to indicate when the page is fully loaded.
        Please be careful about placement */}
            <div id="overviewPageContent"></div>
            {props?.config?.showSesameGradeBanner && (
              <SesameGradeBanner overallCSGrade={overallCSGrade} />
            )}
            <FlexContainer
              className={
                'justify-beetween flex-column fullwidth padlr14 m-padlr12 margt48 m-margt0'
              }
            >
              <ContainerManager
                staticModules={staticModulesThree}
                preventInnerLoading
                isDefaultModuleViewDisabled
                CustomModuleRepository={TodayDashboardModule}
                gapClass={'gap-22'}
                extraAttributes={{
                  showModuleAvailableForYou,
                }}
              />
            </FlexContainer>
          </FlexContainer>
        )}
      <Footer />
    </BodyContainer>
  );
};
